<div class="kt-grid kt-grid--ver kt-grid--root page404">
    <div class="kt-grid__item kt-grid__item--fluid kt-grid  kt-error-v1">
        <div class="kt-error-v1__container">
            <h1 class="kt-error-v1__number">404</h1>
            <p class="kt-error-v1__desc">
                Upps! Página no encontrada
            </p>
        </div>
    </div>
</div>